import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../_common/application/ts/Glob';

import BooleanField from '../../../_common/platform/tsx/BooleanField';
import RadioGroupFieldComponent from '../../../_common/platform/tsx/RadioGroupField';
import { ICreateWidgetLinkOptions, WidgetLink_IncludeStates } from '../ts/stores/WorkspaceStore';

export function WidgetLinkParameters(props: {
    setConfirmValueGetter(getConfirmValue);
    unsetConfirmValueGetter?();

    glob: IGlob;
}) {
    const [anonymousLogin, setAnonymousLogin] = React.useState(false);
    const [showLogo, setShowLogo] = React.useState(false);
    const [linkByName, setLinkByName] = React.useState(false);
    const [useGuidsAsWSID, setUseGuidsAsWSID] = React.useState(false);
    const [includeStateAs, setIncludeStateAs] = React.useState(WidgetLink_IncludeStates.urlParams);

    React.useEffect(() => {
        const getConfirmValue: () => ICreateWidgetLinkOptions = () => {
            return {
                anonymousLogin: anonymousLogin,
                showLogo: showLogo,
                linkByName: linkByName,
                useGuidsAsWSID: useGuidsAsWSID,
                includeStateAs: includeStateAs
            };
        };

        props.setConfirmValueGetter(getConfirmValue);

        return () => {
            if (typeof props.unsetConfirmValueGetter === 'function') {
                props.unsetConfirmValueGetter();
            }
        };
    });

    return (
        <div>
            <div className="col-sm-6 mb-2">
                <BooleanField
                    value={anonymousLogin}
                    allowNull={false}
                    title={'Use Anonymous Login'}
                    onChange={(value: boolean) => {
                        setAnonymousLogin(value);
                    }}
                />
            </div>
            <div className="col-sm-6 mb-2">
                <BooleanField
                    value={showLogo}
                    allowNull={false}
                    title="Show Application Logo"
                    onChange={(value: boolean) => {
                        setShowLogo(value);
                    }}
                />
            </div>
            <div className="col-sm-6 mb-2">
                <BooleanField
                    value={linkByName}
                    allowNull={false}
                    title="Link by Widget Name (must be unique)"
                    onChange={(value: boolean) => {
                        setLinkByName(value);
                    }}
                />
            </div>
            <div className="col-sm-6 mb-2">
                <BooleanField
                    value={useGuidsAsWSID}
                    allowNull={false}
                    title="Use GUID as Workspace Identifier"
                    onChange={(value: boolean) => {
                        setUseGuidsAsWSID(value);
                    }}
                />
            </div>
            <div className="card">
                <div className="card-header">{'Include Filter'}</div>
                <div className="card-body">
                    <RadioGroupFieldComponent
                        value={includeStateAs}
                        options={{
                            name: 'RG_IncludeStateAS',
                            layout: 'vertical',
                            items: [
                                { text: 'as URL Parameters', value: WidgetLink_IncludeStates.urlParams },
                                { text: 'as Persistent State ID', value: WidgetLink_IncludeStates.dbStateId }
                            ]
                        }}
                        onChange={(value: WidgetLink_IncludeStates) => {
                            setIncludeStateAs(value);
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
